import { styled } from '@mui/material';
import {
  ReleaseButtonSlot,
  StudioButtonSlot,
  TrackAddToLibrary,
  TrackCopyLink,
  TrackDownload,
} from '../../../../TrackGrid';

export const StyledStudioButtonSlotContainer = styled(StudioButtonSlot)(
  ({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    '& svg': {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    '.MuiIconButton-root:hover': {
      backgroundColor: theme.palette.grey[700],
    },
    '.MuiIconButton-root:hover svg': {
      color: theme.palette.grey[50],
    },
  })
);

export const StyledReleaseButtonSlotContainer = styled(ReleaseButtonSlot)(
  ({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    '.MuiIconButton-root:hover': {
      backgroundColor: theme.palette.grey[700],
    },
    '.MuiIconButton-root:hover svg': {
      color: theme.palette.grey[50],
    },
  })
);

export const StyledTrackCopyLinkContainer = styled(TrackCopyLink)(
  ({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    '& svg': {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    '.MuiIconButton-root:hover': {
      backgroundColor: theme.palette.grey[700],
    },
    '.MuiIconButton-root:hover svg': {
      color: theme.palette.grey[50],
    },
  })
);

export const StyledTrackAddToLibraryContainer = styled(TrackAddToLibrary)(
  ({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    '.MuiIconButton-root:hover': {
      backgroundColor: theme.palette.grey[700],
    },
    '.MuiIconButton-root:hover svg': {
      color: theme.palette.grey[50],
    },
  })
);

export const StyledTrackDownloadContainer = styled(TrackDownload)(
  ({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    '.MuiIconButton-root:hover': {
      backgroundColor: theme.palette.grey[700],
    },
    '.MuiIconButton-root:hover svg': {
      color: theme.palette.grey[50],
    },
  })
);
